import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-white text-black">
      {/* Logo */}
      <div className="text-center py-12">
        <img 
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/v1754071341/VESHH-EON_TYPE_WEB_ppfyxy.png" 
          alt="VESHH-EON"
          className="mx-auto h-16 md:h-20 w-auto"
        />
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 pb-16">
        {/* Opening Hook */}
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            We don't follow trends. We create them.
          </h1>
        </div>

        {/* Philosophy */}
        <section className="mb-16">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6">The Philosophy</h2>
          <div className="space-y-6 text-lg text-justify leading-relaxed">
            <p>
              VESHH-EON exists in the space between what is and what could be. We believe that clothing is never just fabric—it's the armor you wear into your ambitions, the silent language that speaks before you do. Every thread we weave carries intention. Every silhouette we craft honors the audacity to be unapologetically yourself.
            </p>
            <p>
              In a world obsessed with the temporary, we choose the eternal. While others chase fleeting moments, we build legacies that transcend seasons, cultures, and time itself.
            </p>
          </div>
        </section>

        {/* Genesis */}
        <section className="mb-16">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6">The Genesis</h2>
          <div className="space-y-6 text-lg text-justify leading-relaxed">
            <p>
              It began with a question whispered in a crowded room: <em>What if fashion could make you feel invincible?</em>
            </p>
            <p>
              Born from the restless minds of creators who refused to accept ordinary, VESHH-EON emerged not as a brand, but as a rebellion against mediocrity. We saw a generation hungry for authenticity in an age of imitation, yearning for pieces that would grow with them, evolve with them, become part of their story.
            </p>
            <p>
              Our founders didn't want to dress bodies. They wanted to dress dreams.
            </p>
            <p>
              From late-night sketches in cramped studios to the moment our first piece touched skin, every step was guided by one unwavering truth: that the right garment doesn't just fit your form—it fits your future.
            </p>
          </div>
        </section>

        {/* Vision */}
        <section className="mb-16">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6">The Vision</h2>
          <div className="space-y-6 text-lg text-justify leading-relaxed">
            <p>
              We are building more than a wardrobe. We are architecting a new cultural language.
            </p>
            <p>
              VESHH-EON is where visionaries find their uniform, where creators discover their second skin, where the bold recognize their tribe. We envision a world where personal style becomes personal power, where every individual who wears our pieces carries forward a shared commitment to excellence, innovation, and fearless self-expression.
            </p>
            <p>
              This is not about following—it's about leading. Not about fitting in—it's about standing out while standing together. We are curating a community of the creatively restless, the beautifully ambitious, the quietly revolutionary.
            </p>
            <p>
              Join us, and become part of something that history will remember.
            </p>
          </div>
        </section>

        {/* Closing */}
        <div className="text-center">
          <h3 className="text-2xl md:text-3xl font-bold">
            VESHH-EON. Where vision becomes reality.
          </h3>
        </div>
      </div>
    </div>
  );
};

export default About;
